module.exports = __webpack_public_path__ + "img/logistics.c0ab725c.png";